import React, { Fragment, useState, useEffect, useContext } from 'react';
import { ProjectContext } from '../../../../../../context/Project';
import { formatPrice } from '../../../../../../common/numberFormat';
import { PixelContext } from '../../../../../../context/Pixel';

function TotalEstimation() {
    const { projectMaterials, projectLaborBudget, setTotalBudget } = useContext(ProjectContext);
    const { trackAnalyticsEvent, Events } = useContext(PixelContext);

    const [totalEstimation, setTotalEstimation] = useState(0);
        
    useEffect(() => {
        if (projectMaterials
            && Object.keys(projectMaterials).length > 0
            && projectLaborBudget > 0) {
            let materialTotal = calculateMaterialsTotal(projectMaterials);
            let totalBudget = materialTotal + projectLaborBudget
            setTotalEstimation(totalBudget);
            setTotalBudget(totalBudget);
			trackAnalyticsEvent(Events.ADD_ITEMS_TOTAL_ESTIMATION, {
                materialTotal: formatPrice(materialTotal),
                projectLaborBudget: formatPrice(projectLaborBudget),
                totalBudget: formatPrice(totalBudget)
            });
        } else {
            setTotalEstimation(0);
            setTotalBudget(0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectMaterials, projectLaborBudget]);

    const calculateMaterialsTotal = (materials) => {
        let materialTotal = 0;

        for (let i in materials) {
            materialTotal += materials[i].price * materials[i].quantity;
        }

        return materialTotal;
    }

    return (
        <Fragment>
            <span>Total estimated</span>
            <span>{formatPrice(totalEstimation)}</span>
        </Fragment>
    );
}

export default TotalEstimation;